import gql from 'graphql-tag'
import { dayOrderItems } from '../fragments'

export default gql`
query CAmaster_listDateOrderValues($id: ID!, $dateInterval: FullDateTimeIntervalInput, $date: DateTime) {
	cashAssist {
		listDateOrderValues(filter: {creditClientId: $id, dateInterval: $dateInterval, date: $date}) {
            ...dayOrderItems
		}
	}
}
${dayOrderItems}`
